import { httpsCallable } from 'firebase/functions';

import { getFirebaseFunctions } from '@/lib/firebase/functions';
import { buildAnswerCacheByIdQueryKey } from '@/lib/query-cache/query-keys';
import { resolveBrowserQueryCache, type BrowserQueryCache } from '@/lib/query-cache/query-cache';
import type { GetAnswerCacheByIdRequest, GetAnswerCacheByIdResponse } from '@/types/backend-contracts';

export async function getAnswerCacheById(
  answerCacheId: string,
  options?: { cache?: BrowserQueryCache },
): Promise<GetAnswerCacheByIdResponse> {
  const normalizedAnswerCacheId = answerCacheId.trim();
  const cache = resolveBrowserQueryCache(options?.cache);

  const result = await cache.read(
    buildAnswerCacheByIdQueryKey(normalizedAnswerCacheId),
    async () => {
      const callable = httpsCallable<GetAnswerCacheByIdRequest, GetAnswerCacheByIdResponse>(
        getFirebaseFunctions(),
        'getAnswerCacheById',
      );

      const response = await callable({ answerCacheId: normalizedAnswerCacheId });
      return response.data;
    },
    {
      staleTimeMs: 10 * 60 * 1000,
      cacheTimeMs: 60 * 60 * 1000,
      tags: ['answer-cache'],
    },
  );

  return result.value;
}
